import * as Yup from 'yup';

import { PhoneNumberUtil, Error } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const emailSchema = () => Yup.string().email().required('Required');

function validatePhoneNumber(phoneNumberString) {
  try {
    const internationalPhoneNumber = phoneUtil.parse(phoneNumberString, null);

    if (phoneUtil.isValidNumber(internationalPhoneNumber)) {
      return true;
    }
  } catch (error) {
    if (error.message !== Error.INVALID_COUNTRY_CODE) {
      return false;
    }
  }

  try {
    const spanishPhoneNumber = phoneUtil.parse(phoneNumberString, 'ES');

    return phoneUtil.isValidNumber(spanishPhoneNumber);
  } catch (error) {
    return false;
  }
}

export const timeSchema = () =>
  Yup.string().matches(
    /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
    'Not a valid time'
  );

export const phoneSchema = () =>
  Yup.string()
    .required('Required')
    .test(
      'valid-phone-number',
      'Not a valid phone number',
      validatePhoneNumber
    );

export default Yup.object().shape({
  order_data: Yup.object().shape({
    pickup: Yup.object().shape({
      company_name: Yup.string(),
      address: Yup.string().required('Required'),
      city: Yup.string().required('Required'),
      zipcode: Yup.string().required('Required'),
      country: Yup.string().required('Required'),
      date: Yup.string().required('Required'),
      time_from: timeSchema().required('Required'),
      time_to: timeSchema().required('Required'),
      observations: Yup.string().nullable(),
    }),
    dropoff: Yup.object().shape({
      company_name: Yup.string(),
      address: Yup.string().required('Required'),
      city: Yup.string().required('Required'),
      zipcode: Yup.string().required('Required'),
      country: Yup.string().required('Required'),
      date: Yup.string().required('Required'),
      time_from: timeSchema().required('Required'),
      time_to: timeSchema().required('Required'),
      observations: Yup.string().nullable(),
    }),
    loads_data: Yup.object().shape({
      totals: Yup.object().shape({
        total_weight: Yup.number()
          .positive()
          .transform((value) => (Number.isNaN(value) ? null : value))
          .required('Required'),
        linear_meters: Yup.number()
          .positive()
          .transform((value) => (Number.isNaN(value) ? null : value))
          .nullable(),
        cubic_meters: Yup.number()
          .positive()
          .transform((value) => (Number.isNaN(value) ? null : value))
          .nullable(),
      }),
      loads: Yup.array()
        .of(
          Yup.object().shape({
            number_of_items: Yup.number().required('Required').min(1),
            load_type: Yup.string().required('Required'),
            item_length: Yup.number()
              .positive()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable(),
            item_width: Yup.number()
              .positive()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable(),
            item_height: Yup.number()
              .positive()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable(),
          })
        )
        .min(1),
    }),
    service_type: Yup.object().shape({
      vehicle_type: Yup.string().required('Required'),
      vehicle_details: Yup.array().of(Yup.string()),
    }),
    complementary_info: Yup.object().shape({
      customer_internal_reference: Yup.string().nullable(),
      customer_deadline_date: Yup.string(),
      customer_deadline_time: timeSchema()
        .transform((value) => (value === '' ? null : value))
        .nullable(),
      additional_services: Yup.array().of(Yup.string()),
    }),
  }),
});
